export const assetAndTaskDateFields = ["annualServiceDate", "warrantyExpiry", "installationDate"]
